import type { ReservationSlotTemplate } from '../../../domain/reservationSlots';

/**
 * テンプレートの仕様を短い文字列にする
 *
 * @description
 * 枠間隔・1区間あたりの枠数・パターン種別を「15分・2枠」「15分・3枠・交互」の形で表す。
 * 単一パターンは既定の挙動なので種別を省略する。
 *
 * @param {ReservationSlotTemplate} template - 対象テンプレート
 * @returns {string} 仕様文字列
 *
 * @example
 * formatTemplateSpec(pillTemplate); // "15分・2枠"
 * formatTemplateSpec(fullTemplate); // "15分・3枠・交互"
 */
export function formatTemplateSpec(template: ReservationSlotTemplate): string {
  const base = `${template.intervalMinutes}分・${template.slotsPerInterval}枠`;
  return template.patternType === 'alternate' ? `${base}・交互` : base;
}

/**
 * テンプレート名と仕様をまとめた表示ラベルを作る
 *
 * @description
 * セレクトボックスやサマリ表示で使う「ピル標準（15分・2枠）」形式のラベル。
 *
 * @param {ReservationSlotTemplate} template - 対象テンプレート
 * @returns {string} 表示ラベル
 *
 * @example
 * formatTemplateLabel(fullTemplate); // "フルカテゴリ（15分・3枠・交互）"
 */
export function formatTemplateLabel(template: ReservationSlotTemplate): string {
  return `${template.name}（${formatTemplateSpec(template)}）`;
}
